import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, ButtonToolbar, Modal } from 'reactstrap';
import classNames from 'classnames';
import { RTLProps, ThemeProps } from '../../prop-types/ReducerProps';

class ModalComponent extends PureComponent {
  static propTypes = {
    title: PropTypes.string,
    message: PropTypes.string,
    color: PropTypes.string,
    colored: PropTypes.bool,
    header: PropTypes.bool,
    buttonToolbar: PropTypes.bool,
    rtl: RTLProps.isRequired,
    theme: ThemeProps.isRequired,
    children: PropTypes.node,
    isOpen: PropTypes.bool,
    toggle: PropTypes.func.isRequired,
    onOk: PropTypes.func,
    onCancel: PropTypes.func,
    okButtonText: PropTypes.string,
    cancelButtonText: PropTypes.string,
    size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
  };

  static defaultProps = {
    title: '',
    message: '',
    color: 'primary',
    colored: false,
    header: false,
    buttonToolbar: false,
    children: null,
    isOpen: false,
    onOk: null,
    onCancel: null,
    okButtonText: 'Ok',
    cancelButtonText: 'Cancel',
    size: 'md',
  };

  getIcon = (color) => {
    switch (color) {
      case 'primary':
        return <span className="lnr lnr-pushpin modal__title-icon" />;
      case 'success':
        return <span className="lnr lnr-thumbs-up modal__title-icon" />;
      case 'warning':
        return <span className="lnr lnr-flag modal__title-icon" />;
      case 'danger':
        return <span className="lnr lnr-cross-circle modal__title-icon" />;
      default:
        return <></>;
    }
  }

  render() {
    const {
      color,
      title,
      message,
      colored,
      header,
      buttonToolbar,
      rtl,
      theme,
      children,
      isOpen,
      toggle,
      onOk,
      onCancel,
      okButtonText,
      cancelButtonText,
      size,
    } = this.props;

    const modalClass = classNames({
      'modal-dialog--colored': colored,
      'modal-dialog--header': header,
      'theme-dark': theme.className === 'theme-dark',
      'theme-light': theme.className === 'theme-light',
    });

    return (
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        modalClassName={`${rtl.direction}-support`}
        className={`modal-dialog--${color} ${modalClass}`}
        size={size}
      >
        <div className="modal__header">
          <button className="lnr lnr-cross modal__close-btn" type="button" onClick={toggle} />
          {!header && this.getIcon(color)}
          <h4 className="text-modal  modal__title">{title}</h4>
        </div>
        <div className="modal__body">
          {children || message}
        </div>
        {
          buttonToolbar ? (
            <ButtonToolbar className="modal__footer">
              <Button className="modal_cancel" onClick={onCancel || toggle}>{cancelButtonText}</Button>{' '}
              <Button className="modal_ok" outline={colored} color={color} onClick={onOk || toggle}>
                {okButtonText}
              </Button>
            </ButtonToolbar>
          ) : null
        }
      </Modal>
    );
  }
}

export default connect(state => ({
  rtl: state.rtl,
  theme: state.theme,
}))(ModalComponent);
